import React, { FunctionComponent } from "react";
import styles from "../css/Footer.module.css";
import logo from "../../assets/logo_mm.png";
import TelegramIcon from "@mui/icons-material/Telegram";

import InstagramIcon from "@mui/icons-material/Instagram";
import { useSelector } from "react-redux";
const Footer = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
      </div>
      <div>
        <div className={styles.contacts}>
          <div className={styles.contactInformation}>
            <span className={styles.emailInfo}>
              info@marianamelnic.com
              <br />
            </span>
            {/* <span className={styles.phoneNumber}>+40744301259</span> */}
          </div>
          <div className={styles.icon}>
            <div className={styles.iconTg} />
            <a
              href="https://www.instagram.com/mariana.melnic13/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon style={{ fill: "#C4B57C", cursor: "pointer" }} />
            </a>{" "}
            <TelegramIcon style={{ fill: "#C4B57C" }} />
          </div>
        </div>
        <div
          className={styles.arrowSvhg}
          onClick={() => {
            console.log("Arrow clicked");
            // Try multiple scroll methods
            try {
              // Method 1: scrollTo with smooth behavior
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });

              // Method 2: as fallback, scroll the documentElement and body
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;

              // Method 3: scrollIntoView of the top element
              document.getElementById("root")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            } catch (error) {
              // Fallback to instant scroll if smooth scroll fails
              window.scrollTo(0, 0);
            }
          }}
        >
          <svg
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="17.5"
              cy="17.5"
              r="17"
              transform="rotate(90 17.5 17.5)"
              fill="#C4B57C"
              stroke="#C4B57C"
            />
            <path
              d="M17.3536 12.6464C17.1583 12.4512 16.8417 12.4512 16.6464 12.6464L13.4645 15.8284C13.2692 16.0237 13.2692 16.3403 13.4645 16.5355C13.6597 16.7308 13.9763 16.7308 14.1716 16.5355L17 13.7071L19.8284 16.5355C20.0237 16.7308 20.3403 16.7308 20.5355 16.5355C20.7308 16.3403 20.7308 16.0237 20.5355 15.8284L17.3536 12.6464ZM17.5 35L17.5 13L16.5 13L16.5 35L17.5 35Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <span className={styles.copyright}>
        {language === "EN" && "© 2025 All rights reserved."}
        {language === "RO" && "© 2025 Toate drepturile rezervate."}
      </span>
    </div>
  );
};

export default Footer;
